export default __webpack_public_path__ + "static/media/36I-102627_-15536_0.50698d69.jpg";